export default "__VITE_ASSET__9f03045d__"